import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export interface DataItem {
  id: string;
  name: string;
  price: number;
  unit:string;
  discount: number;
}

export interface DataState extends EntityState<DataItem> {
  loading: boolean;
  error: string | null;
}

export const adapter: EntityAdapter<DataItem> = createEntityAdapter<DataItem>();

export const initialState: DataState = adapter.getInitialState({
  loading: false,
  error: null,
});


export interface TestItem {
  id: number;
  test_code:string;
  name: string;
  category: any;
  investigations: string;
  sample: string;
  temp: string;
  method: string;
  unit: string;
  range_: string;
  schedule: string;
  delivery: string;
  instructions: string;
  active: boolean;
  display_priority: number;
  gender: string;
  price: number;
  discounted: boolean;
  disc_amount: number;
  discount_rate: number;
  notes: string;
}

export interface TestState extends EntityState<TestItem> {
  loading: boolean;
  error: string | null;
}

export const Testadapter: EntityAdapter<TestItem> = createEntityAdapter<TestItem>();

export const initialTestItemState: TestState = Testadapter.getInitialState({
  loading: false,
  error: null,
});
